import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'

/*
const http = Axios.create({})
http.interceptors.response.use(function (response) {
	var appResp = response.data.response;
	//console.log("axios http.interceptors.response.use");
	if (appResp.status == "-7") {
		console.log("axios http.interceptors.response.use: need login");
	}
}, function (error) { })
Vue.prototype.$http = http
*/

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
